<template>
  <div :class="colClass" :style="colStyle"><slot></slot></div>
</template>

<script>
const classPrefix = 'bcc-col'

export default {
  name: 'BccCol',
  props: {
    span: [Number, String],
    order: [Number, String],
    offset: [Number, String],
    push: [Number, String],
    pull: [Number, String]
  },
  inject: ['rowData'],
  computed: {
    colClass () {
      let classList = [
        classPrefix,
        {
          [`${classPrefix}-${this.span}`]: this.span,
          [`${classPrefix}-order-${this.order}`]: this.order,
          [`${classPrefix}-offset-${this.offset}`]: this.offset,
          [`${classPrefix}-push-${this.push}`]: this.push,
          [`${classPrefix}-pull-${this.pull}`]: this.pull
        }
      ]
      return classList
    },
    colStyle () {
      let style = {}
      if (this.rowData && this.rowData.gutter !== 0) {
        style = {
          paddingLeft: `${this.rowData.gutter / 2}px`,
          paddingRight: `${this.rowData.gutter / 2}px`
        }
      }
      return style
    }
  }
}
</script>
